export const APP_BUILD_ID_STORAGE_KEY = 'sf-app-build-id';
export const APP_DISPLAY_VERSION_STORAGE_KEY = 'sf-app-display-version';

/** How often to re-check version.txt while the app is open. */
export const APP_VERSION_CHECK_INTERVAL_MS = 30 * 60 * 1000;

/** Delay before reload so the user can read the toast. */
export const APP_VERSION_RELOAD_DELAY_MS = 2500;
